export const Z_INDEX = {
  OVER_STATUS_BAR: 100,
  MODAL_INDEX: 2147483646, // Maximum z-index value minus 1 to ensure modals are on top
};

export const SORT_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc",
};
